<script lang="ts" setup>
import { VLoader, useThemeStore } from "@app/core";
import { computed, ref, watch, type Component } from "vue";
import { useRoute, useRouter } from "vue-router";

import AuthLayout from "./AuthLayout.vue";
import DefaultLayout from "./DefaultLayout.vue";
import EmptyLayout from "./EmptyLayout.vue";

import { useGlobalFiltersStore } from "@/shared/stores/useGlobalFiltersStore";
import { useUserStore } from "@/shared/stores/useUserStore";

const layouts: Record<string, Component> = {
  default: DefaultLayout,
  auth: AuthLayout,
  empty: EmptyLayout,
};

const route = useRoute();
const router = useRouter();
const themeStore = useThemeStore();
const userStore = useUserStore();
const globalFiltersStore = useGlobalFiltersStore();

const isRouterReady = ref(false);
router.isReady().then(() => {
  isRouterReady.value = true;
});

themeStore.initTheme();

watch(
  () => userStore.user,
  async () => {
    if (!userStore.user) return;
    await router.isReady();
    await globalFiltersStore.initFilters(
      route.query as Record<string, string | undefined>,
    );
  },
  { immediate: true },
);

const layout = computed(() => {
  if (!isRouterReady.value) return null;
  const layoutName = (route.meta?.layout as string) || "default";
  return layouts[layoutName] ?? layouts.default;
});
</script>

<template>
  <component
    :is="layout"
    v-if="layout"
  />
  <div
    v-else
    class="w-full min-h-screen flex justify-center items-center bg-mainBg"
  >
    <VLoader />
  </div>
</template>
